<script lang="ts">
  let { color = 'currentColor' } = $props()
</script>

<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M4 6.99998H10M7 3.99998V9.99998M2 21.3175C2 21.3175 6.11448 16.5272 6.21386 16.5007C6.31324 16.4742 8.44995 17 8.44995 17M23 21.3175C23 21.3175 18.8855 16.5272 18.7861 16.5007C18.6868 16.4742 17 17 17 17M12.5 13.5L10.9794 11.0002M21.6434 11.6532L22.0641 9.86757C22.0641 9.86757 22.5246 8.2674 22.4848 8.08196C22.4451 7.89652 18.165 3.0266 18.0126 3.0001C17.8701 2.97533 13.5 4.99992 13.5 4.99992M9.14995 19.5H16C16.3866 19.5 16.7 19.1866 16.7 18.8V14.2C16.7 13.8134 16.3866 13.5 16 13.5H9.14995C8.76335 13.5 8.44995 13.8134 8.44995 14.2V18.8C8.44995 19.1866 8.76335 19.5 9.14995 19.5Z"
    stroke={color}
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>
